function yyyy_mm_dd_date_format({ i_date, add_days, sub_days }) {
    let date;

    // If i_date is provided, parse it to a local Date object
    if (i_date) {
        date = new Date(`${i_date}T00:00:00`);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset()); // Adjust for local timezone
    } else {
        date = new Date(); // Current date if i_date is not provided
    }

    if (add_days)
        date.setDate(date.getDate() + add_days);
    if (sub_days)
        date.setDate(date.getDate() - sub_days);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export default yyyy_mm_dd_date_format;